import { render, staticRenderFns } from "./GameDialog.vue?vue&type=template&id=497c404b&scoped=true&"
import script from "./GameDialog.vue?vue&type=script&lang=js&"
export * from "./GameDialog.vue?vue&type=script&lang=js&"
import style0 from "./GameDialog.vue?vue&type=style&index=0&id=497c404b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "497c404b",
  null
  
)

export default component.exports